<div class="section">
  <div class="container-max max-w-3xl prose">
    <h1 class="font-sans text-headline-lg mb-6">Política de privacidad</h1>
    <p class="text-on-surface-variant mb-4">
      En Chambia protegemos tus datos personales conforme a la normativa de protección de datos vigente en cada país donde
      operamos (México, Colombia, Ecuador, Costa Rica, Perú, Argentina, Chile, Panamá, Uruguay, República Dominicana y
      Guatemala).
    </p>
    <h2 class="font-bold text-lg mt-8 mb-2">1. Datos que recopilamos</h2>
    <p class="text-on-surface-variant mb-4">
      Número de WhatsApp, nombre, ciudad, país, habilidades, experiencia y preferencias laborales que compartes durante tu
      conversación con Chambia.
    </p>
    <h2 class="font-bold text-lg mt-8 mb-2">2. Uso de tus datos</h2>
    <p class="text-on-surface-variant mb-4">
      Usamos tus datos para encontrar vacantes relevantes mediante matching con IA y para compartir tu perfil únicamente
      con empresas verificadas cuando decides postular.
    </p>
    <h2 class="font-bold text-lg mt-8 mb-2">3. Tus derechos</h2>
    <p class="text-on-surface-variant mb-4">
      Puedes solicitar acceso, rectificación o eliminación de tus datos en cualquier momento escribiéndonos por WhatsApp.
    </p>
  </div>
</div>
